// Contenu de page rendu juste après #main-content, au niveau de <body> (le
// conteneur Inertia #app est transparent) : modales et balisage qui sortent de
// #main-content mais doivent rester avant les éléments de fin de la coquille
// (menu des langues, barre du bas, chatbot). Un portail vers <body> les
// mettrait après eux.
//
// La page rend <AfterMain>…</AfterMain> ; la coquille rend <AfterMainOutlet />.
// Côté client seulement, comme un portail : le serveur ne rend rien ici.
import { useLayoutEffect, useSyncExternalStore, type ReactNode } from 'react'

let content: ReactNode = null
const listeners = new Set<() => void>()
const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
const publish = (node: ReactNode) => {
  content = node
  listeners.forEach((listener) => listener())
}

export function AfterMain({ children }: { children: ReactNode }) {
  useLayoutEffect(() => publish(children), [children])
  useLayoutEffect(() => () => publish(null), [])
  return null
}

export function AfterMainOutlet() {
  const node = useSyncExternalStore(subscribe, () => content, () => null)
  return <>{node}</>
}
